import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  delay?: number;
}

const TestimonialCard = ({ quote, author, role, delay = 0 }: TestimonialCardProps) => {
  return (
    <motion.div 
      className="card"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true, margin: "-100px" }}
    >
      <Quote className="text-primary/40 mb-4" size={32} />
      <p className="text-neutral-700 mb-6 italic">"{quote}"</p>
      <div>
        <p className="font-sans font-semibold">{author}</p>
        <p className="text-neutral-500 text-sm">{role}</p>
      </div>
    </motion.div>
  );
};

export default TestimonialCard;